import { Observable } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { switchMap, catchError } from 'rxjs/operators';
import { getParams, GlobalEnvironment } from 'Helpers';
import { ProjectDetails } from "Models";
import { StatusCodeService } from 'Services';
import { msalTemp } from 'Contexts/AuthProvider';

export class ProjectDetailsService {

    static GetProjectDetails(): Observable<ProjectDetails[]> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...getParams, headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };

        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/ProjectDetails`, params).pipe(
            switchMap(response => {
                if (response.ok) { // use http
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(StatusCodeService.GetMessage(response.status, "GetRequest"));
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }
}